"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsMediasoupWebrtc = exports.supportsFlvHttp = exports.supportsNativeHls = exports.supportsMp4 = exports.supportsHlsjs = exports.H264_CAPABILITY = exports.OPUS_CAPABILITY = exports.VP8_CAPABILITY = void 0;
exports.getNetworkConnectionType = getNetworkConnectionType;
/* eslint-disable import/no-cycle */
const log_client_1 = require("@video/log-client");
const adapter_1 = require("../../../api/adapter");
const support_1 = require("../support");
const mediasoup_device_1 = require("../mediasoup-device");
const user_agent_1 = require("../../adapters/utils/user-agent");
exports.VP8_CAPABILITY = {
    clockRate: 90000,
    kind: "video",
    mimeType: "video/VP8",
};
exports.OPUS_CAPABILITY = {
    channels: 2,
    clockRate: 48000,
    kind: "audio",
    mimeType: "audio/opus",
};
exports.H264_CAPABILITY = {
    clockRate: 90000,
    kind: "video",
    mimeType: "video/H264",
    parameters: {
        "packetization-mode": 1,
    },
};
const canCheckPlayType = (el) => {
    return "canPlayType" in el && typeof el.canPlayType === "function";
};
const supportsHlsjs = (logger) => {
    var _a;
    if (!adapter_1.device.isImplements(adapter_1.Feature.HLSJS)) {
        logger === null || logger === void 0 ? void 0 : logger.info("HlsJsPlayer is NOT supported");
        return false;
    }
    if (adapter_1.device.isSafari) {
        logger === null || logger === void 0 ? void 0 : logger.info("HlsJsPlayer is NOT supported in Safari, use Native Hls player instead", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    // win chrome 51 and below have a bug in mse causing black screens on bitrate switches
    if ((0, user_agent_1.oldWindowsChrome)(adapter_1.device)) {
        logger === null || logger === void 0 ? void 0 : logger.info("HlsJsPlayer is NOT supported", {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    // This is directly copied from the hls library so that the library can be dynamically loaded in
    if (!adapter_1.device.isImplements(adapter_1.Feature.MEDIA_SOURCE) ||
        !((_a = adapter_1.device.MediaSource) === null || _a === void 0 ? void 0 : _a.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'))) {
        logger === null || logger === void 0 ? void 0 : logger.info("HlsJsPlayer is NOT supported", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    logger === null || logger === void 0 ? void 0 : logger.debug("HlsJsPlayer is supported", {
        ...adapter_1.device.browserInfo,
        platform: adapter_1.device.platform,
    });
    return true;
};
exports.supportsHlsjs = supportsHlsjs;
const supportsMp4 = (logger) => {
    var _a;
    if ((0, user_agent_1.safariWithoutMp4Support)(adapter_1.device)) {
        logger === null || logger === void 0 ? void 0 : logger.info("MP4Player is NOT supported", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    /**
     * IE doesn't support userAgentData
     */
    if (adapter_1.device.isIE) {
        logger === null || logger === void 0 ? void 0 : logger.info("MP4Player is NOT supported", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    if ((0, user_agent_1.chromeWithoutMp4Support)(adapter_1.device)) {
        logger === null || logger === void 0 ? void 0 : logger.info("MP4Player is NOT supported", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    if (!(adapter_1.device.isImplements(adapter_1.Feature.WEB_SOCKET) &&
        adapter_1.device.isImplements(adapter_1.Feature.MEDIA_SOURCE) &&
        adapter_1.device.isImplements(adapter_1.Feature.MEDIA_DEVICE) &&
        adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE) &&
        adapter_1.device.isImplements(adapter_1.Feature.DEBUGGING) &&
        ((_a = adapter_1.device.MediaSource) === null || _a === void 0 ? void 0 : _a.isTypeSupported('video/mp4; codecs="avc1.4d4028,mp4a.40.2"')))) {
        logger === null || logger === void 0 ? void 0 : logger.info("MP4Player is NOT supported", {
            ...adapter_1.device.browserInfo,
            platform: adapter_1.device.platform,
        });
        return false;
    }
    logger === null || logger === void 0 ? void 0 : logger.debug("MP4Player is supported", {
        ...adapter_1.device.browserInfo,
        platform: adapter_1.device.platform,
    });
    return true;
};
exports.supportsMp4 = supportsMp4;
const supportsNativeHls = (logger) => {
    if (adapter_1.device.isIosDevice == null || (!adapter_1.device.isIosDevice && !adapter_1.device.isSafari)) {
        logger === null || logger === void 0 ? void 0 : logger.debug("NativeHlsPlayer is NOT supported on non Safari browsers outside of iOS");
        return false;
    }
    if (!adapter_1.device.isImplements(adapter_1.Feature.CREATE_VIDEO_ELEMENT)) {
        logger === null || logger === void 0 ? void 0 : logger.info("NativeHlsPlayer is NOT supported");
        return false;
    }
    const el = adapter_1.device.createVideoElement();
    if (!(canCheckPlayType(el) &&
        (el.canPlayType("application/vnd.apple.mpegURL") === "probably" ||
            el.canPlayType("application/vnd.apple.mpegURL") === "maybe"))) {
        logger === null || logger === void 0 ? void 0 : logger.info("NativeHlsPlayer is NOT supported", {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    logger === null || logger === void 0 ? void 0 : logger.debug("NativeHlsPlayer is supported", {
        ...adapter_1.device.browserInfo,
        platform: adapter_1.device.platform,
    });
    return true;
};
exports.supportsNativeHls = supportsNativeHls;
const supportsFlvHttp = async (logger) => {
    var _a, _b;
    if (adapter_1.device.isSafari) {
        logger === null || logger === void 0 ? void 0 : logger.debug("FlvHttpPlayer is NOT supported on non Safari browsers");
        return false;
    }
    if (adapter_1.device.isImplements(adapter_1.Feature.MPEGTS)) {
        await adapter_1.device.loadMpegtsScript();
        const supported = (_b = (_a = adapter_1.device.mpegts) === null || _a === void 0 ? void 0 : _a.isSupported()) !== null && _b !== void 0 ? _b : false;
        if (!supported) {
            logger === null || logger === void 0 ? void 0 : logger.info("FlvHttpPlayer is NOT supported");
        }
        return supported;
    }
    logger === null || logger === void 0 ? void 0 : logger.debug("NativeHlsPlayer is supported", { ...adapter_1.device.browserInfo });
    return true;
};
exports.supportsFlvHttp = supportsFlvHttp;
const supportsMediasoupWebrtc = async (player, logger) => {
    const support = new support_1.Support(logger ? new log_client_1.LoggerCore("VDC-core").extend(logger) : new log_client_1.LoggerCore("VDC-core"));
    await support.ready;
    const isSupported = support.supports("h264");
    if (!isSupported) {
        return false;
    }
    if (!adapter_1.device.isImplements(adapter_1.Feature.MEDIA_STREAM)) {
        logger === null || logger === void 0 ? void 0 : logger.info(`${player} is NOT supported`);
        return false;
    }
    const codecs = [exports.OPUS_CAPABILITY];
    if (adapter_1.device.isAndroidDevice) {
        codecs.push(exports.VP8_CAPABILITY);
    }
    else {
        codecs.push(exports.H264_CAPABILITY);
    }
    try {
        const dev = (0, mediasoup_device_1.createMediasoupDevice)();
        await dev.load({ routerRtpCapabilities: { codecs } });
        const avSupport = {
            audio: dev.canProduce("audio"),
            video: dev.canProduce("video"),
        };
        if (!dev.canProduce("audio") || !dev.canProduce("video")) {
            logger === null || logger === void 0 ? void 0 : logger.info(`${player} is NOT supported`, {
                ...{ browserInfo: adapter_1.device.browserInfo, avSupport },
            });
            return false;
        }
        logger === null || logger === void 0 ? void 0 : logger.debug(`${player} is supported`, {
            ...{ browserInfo: adapter_1.device.browserInfo, avSupport },
        });
        return true;
    }
    catch (err) {
        logger === null || logger === void 0 ? void 0 : logger.info(`${player} is NOT supported`, {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
};
exports.supportsMediasoupWebrtc = supportsMediasoupWebrtc;
function getNetworkConnectionType() {
    var _a, _b;
    let connectionType = "information unavailable";
    let connectionEffectiveType = "information unavailable";
    if (adapter_1.device.isImplements(adapter_1.Feature.NETWORK_INFORMATION)) {
        if ((_a = adapter_1.device === null || adapter_1.device === void 0 ? void 0 : adapter_1.device.connection) === null || _a === void 0 ? void 0 : _a.type) {
            connectionType = adapter_1.device.connection.type;
        }
        if ((_b = adapter_1.device === null || adapter_1.device === void 0 ? void 0 : adapter_1.device.connection) === null || _b === void 0 ? void 0 : _b.effectiveType) {
            connectionEffectiveType = adapter_1.device.connection.effectiveType;
        }
    }
    return [connectionType, connectionEffectiveType];
}
//# sourceMappingURL=browser.js.map